import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Badge } from "V2.0/common/badge";
import { DocumentIcon } from "@heroicons/react/24/outline";
import TabsWithBadge from "V2.0/common/tabsWithBadge";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

export default function MCubeEngageWhatsappTemplates(props) {
  const { templates, tabs, setActiveTab } = props;

  const renderTemplatesLoading = (
    <div className="flex items-center justify-center h-full mx-auto">
      <AiOutlineLoading3Quarters className="animate-spin" />
    </div>
  );

  const renderTemplatesEmpty = (
    <div className="p-8 flex flex-col items-center justify-center h-80 gap-y-4">
      <p className="text-sm">No templates available</p>
    </div>
  );

  const renderTemplatesTable = (
    <Table>
      <TableHead>
        <TableHeader>Name</TableHeader>
        <TableHeader>Language</TableHeader>
        <TableHeader>Status</TableHeader>
        <TableHeader>Category</TableHeader>
      </TableHead>
      <TableBody>
        {templates.data.map((whatsappTemplate, idx) => {
          const { name, language, status, category } = whatsappTemplate;

          return (
            <TableRow key={idx}>
              <TableCell>
                <div className="flex gap-x-2 items-center">
                  <DocumentIcon className="size-4" />
                  <p className="font-semibold text-sm">{name}</p>
                </div>
              </TableCell>
              <TableCell>
                <Badge>{language}</Badge>
              </TableCell>
              <TableCell>
                <Badge>{status}</Badge>
              </TableCell>
              <TableCell>
                <Badge>{category}</Badge>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );

  const isTemplatesLoading = templates.loading;
  const isTemplatesEmpty = !isTemplatesLoading && templates.data.length === 0;

  return (
    <div className="border rounded-lg flex flex-col h-full flex-1 overflow-scroll">
      <div className="bg-gray-50 px-4 flex-shrink-0">
        <TabsWithBadge
          tabs={tabs}
          onTabChange={(e, { tab, index }) => setActiveTab(tab.name)}
        />
      </div>
      <div className="p-4 flex-1 min-h-0 h-full overflow-y-scroll">
        {isTemplatesLoading && renderTemplatesLoading}
        {isTemplatesEmpty ? renderTemplatesEmpty : renderTemplatesTable}
      </div>
    </div>
  );
}
